import './core/Sentry'
// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'

import { loadComponents, removeComponents } from './core/componentUtils'
// set basepath of project for webpack
import { android, basePath, CMS, iOS } from './core/config'
import EventBus from './core/EventBus'
import { EVENTS } from './core/Events'
import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
import Nette from './nette/NetteForms'
import { runLazyImages } from './services/LazyImages'
import NajaService from './services/Naja'
import ScrollService, {
  scrollToElement,
  setScrollPosition,
} from './services/Scroll'
import { scrollHistory } from './services/ScrollHistory'
import { runSwup } from './services/Swup'
import { runScriptsInsideElement } from './utils/script'

__webpack_public_path__ = `${basePath}/assets/frontend/js/`

function isNativeScroll() {
	return android || iOS || CMS || (typeof DISABLE_SMOOTH_SCROLL !== 'undefined' && DISABLE_SMOOTH_SCROLL) || document.body.classList.contains('u-nativeScroll')
}

window.Nette = Nette
Nette.initOnLoad()

NajaService.formsHandler.netteForms = Nette
NajaService.initialize()

new TouchMouseInputResolver()

if (isNativeScroll()) {
    ScrollService.useNative()
    setScrollPosition()
} else {
    ScrollService.useVirtual()
        .catch(() => ScrollService.useNative())
        .finally(() => setScrollPosition())
}

loadComponents()

runLazyImages()

runSwup({
	Nette,
	ScrollService,
	EventBus,
	EVENTS,
	scrollToElement,
	loadComponents,
	removeComponents,
	scrollHistory,
    setScrollPosition,
	runScriptsInsideElement,
	isNativeScroll,
	NajaService,
})
